import { useCallback } from "react";
import {
  FileFragment,
  MessageFragment,
  MessageThreadFragment,
} from "gql/graphql";
import { FORWARD_DRAFT_ID } from "modules/utils/Constants";
import useMessageThreadDraft from "./use-message-thread-draft";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  draftId?: string;
  messageThread: MessageThreadFragment;
  message: MessageFragment;
  file?: FileFragment;
  drawerType?: DRAWER_TYPE;
}

const useForwardMessage = ({
  draftId = FORWARD_DRAFT_ID,
  messageThread,
  message,
  file,
  drawerType = DRAWER_TYPE.FORWARD_MESSAGE_THREAD,
}: IProps) => {
  const { openDrawer } = useOverlay();
  const { createDraft, setQuotedMessages, setRelatedMessageThread, copyFiles } =
    useMessageThreadDraft({ draftId });

  const createLinkedThread = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      await createDraft(
        {
          type: messageThread.type,
          draftType: "new-thread",
        },
        true,
      );
      await setQuotedMessages(message);
      await setRelatedMessageThread(messageThread);
      if (file) {
        await copyFiles(file);
      }
      openDrawer({
        type: drawerType,
        forwardToState: file ? "select-forward-to" : undefined,
      });
    },
    [
      createDraft,
      copyFiles,
      drawerType,
      file,
      message,
      messageThread,
      openDrawer,
      setQuotedMessages,
      setRelatedMessageThread,
    ],
  );

  return {
    createLinkedThread,
  };
};

export default useForwardMessage;
